import React from 'react';
import { AssignVideosView } from './view';
import { useAssignVideos } from './presenter';
import { Route } from '../../../components/layout/ProtectedLayout';

type Props = { machineId: string; navigate: (r: Route) => void };

const AssignVideosPage: React.FC<Props> = ({ machineId, navigate }) => {
  const vm = useAssignVideos(machineId, () => navigate({ name: 'machines/view', params: { id: machineId } }));
  return (
    <AssignVideosView
      machineId={machineId}
      assigned={vm.state.assigned}
      unassigned={vm.state.unassigned}
      loading={vm.state.loading}
      saving={vm.state.saving}
      error={vm.state.error}
      onBack={() => navigate({ name: 'machines/view', params: { id: machineId } })}
      onAssign={vm.actions.assign}
      onUnassign={vm.actions.unassign}
      onMoveUp={(id) => vm.actions.move(id, -1)}
      onMoveDown={(id) => vm.actions.move(id, 1)}
      onSave={vm.actions.save}
    />
  );
};

export default AssignVideosPage;
